import { cn } from "@/lib/utils";

interface ProductTagProps {
  label: string;
  /** Pulse-blue fill for emphasis tags like "Predictable". */
  variant?: "default" | "emphasis" | "onColor";
  className?: string;
}

const PRODUCT_TAG_BASE =
  "text-ds-label-md inline-flex h-5 w-fit items-center rounded-ds-s px-2 py-1 font-medium leading-none";

/**
 * Product card tag (Figma 8196:82089 Tag / type Warning, icon=false).
 */
export function ProductTag({
  label,
  variant = "default",
  className,
}: ProductTagProps) {
  const isEmphasis = variant === "emphasis";
  const isOnColor = variant === "onColor";

  return (
    <span
      className={cn(
        PRODUCT_TAG_BASE,
        isEmphasis && "bg-pulse-700 text-grey-0",
        isOnColor && "bg-pulse-600 text-grey-0",
        !isEmphasis && !isOnColor && "bg-grey-100 text-grey-950",
        className
      )}
    >
      {label}
    </span>
  );
}
